<template>
    <div>

        <br><br>

        <div class="container">

            <div class="card">

                <div class="card-header">
                    <h2>Párametros de configuración</h2>
                </div>

                <div class="card-body">

                    <div class="row">

                        <div class="col-4">
                            <div class="input-group">
                                <label>Usuario:</label> &nbsp;
                                <input type="text" v-model="rabbit_user" class="form-control">
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="input-group">
                                <label>Password:</label> &nbsp;
                                <input type="text" v-model="rabbit_pass" class="form-control">
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="input-group">
                                <label>Exchange:</label> &nbsp;
                                <input type="text" v-model="rabbit_exchange" class="form-control">
                            </div>
                        </div>

                    </div>

                    <br><br>

                    <div class="row">

                        <div class="col-4">
                            <div class="input-group">
                                <label>Host:</label> &nbsp;
                                <input type="text" v-model="rabbit_host" class="form-control">
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="input-group">
                                <label>Puerto:</label> &nbsp;
                                <input type="number" v-model="rabbit_port" class="form-control">
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="input-group">
                                <label>Tiempo(en minutos):</label> &nbsp;
                                <input type="number" v-model="rabbit_tiempo" class="form-control">
                            </div>
                        </div>

                    </div>

                    <br>

                    <div class="row">
                        <div class="col-12">
                            <button type="button" class="btn btn-primary float-left" @click="Guardar"
                                :disabled="bandDisabled">Guardar</button>
                        </div>
                    </div>

                </div>

            </div>

            <br><br>

            <div v-if="textoConexionRabbit != null">

                <div v-if="textoConexionRabbit == 'conexionRealizada'">
                    <div class="card text-white bg-success">
                        <div class="card-body">
                            <span class="float-left">CONEXIÓN EXITOSA <i class="fas fa-check-circle"></i></span>
                        </div>
                    </div>
                </div>

                <div v-else>
                    <div class="card text-white bg-danger" style="padding: 0px;">
                        <div class="card-body">
                            <span class="float-left">{{ textoConexionRabbit }} <i class="fas fa-times-circle"></i></span>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <modalGuardado :texto="textoModal" v-if="bandModalGuardado"></modalGuardado>

    </div>
</template>

<style>
label {
    margin-bottom: 0;
    margin-top: 0.3rem; 
}
</style>

<script>
import notify from "devextreme/ui/notify";
import modalGuardado from "../components/modalGuardado"
export default {
    components: {
        "modalGuardado": modalGuardado,
    },
    data() {
        return {
            _idBucket: undefined,
            rabbit_host: undefined,
            rabbit_port: undefined,
            rabbit_user: undefined,
            rabbit_pass: undefined,
            rabbit_exchange: undefined,
            rabbit_tiempo: undefined,
            bandDisabled: false,
            bandModalGuardado: false,
            textoModal: '',
            textoConexionRabbit: null
        }
    },
    async created() {
        await this.inicio();
    },
    methods: {

        async inicio() {

            try {

                let resp = await this.axios.get("./api" + "/configParams");

                if (resp && resp.data && resp.data.length && resp.data.length > 0) {
                    this.rabbit_host = resp.data[0].rabbit_host;
                    this.rabbit_port = resp.data[0].rabbit_port;
                    this.rabbit_user = resp.data[0].rabbit_user;
                    this.rabbit_pass = resp.data[0].rabbit_pass;
                    this.rabbit_exchange = resp.data[0].rabbit_exchange;
                    this.rabbit_tiempo = resp.data[0].rabbit_tiempo;
                    this._idBucket = resp.data[0]._id;
                    this.textoConexionRabbit = resp.data[0].estadoConexionRabbit;
                    console.log("TABLA CONFIG CONT DATOS");
                } else {
                    this.textoConexionRabbit = "SIN CONEXIÓN"
                }

            } catch (error) {
                this.bandDisabled = true;
                notify("SE PRODUJO UN ERROR", "error", 3000);
                console.log("ERROR AL CARGAR LOS DATOS INCIALES");
                console.error(error);
            }
        },

        async Guardar() {

            try {

                if (
                    this.rabbit_host && this.rabbit_host.trim() != "" &&
                    this.rabbit_user && this.rabbit_user.trim() != "" &&
                    this.rabbit_pass && this.rabbit_pass.trim() != "" &&
                    this.rabbit_exchange && this.rabbit_exchange.trim() != "" &&
                    this.rabbit_port.toString().trim() != "" &&
                    this.rabbit_tiempo.toString().trim() != ""
                ) {

                    if (this.rabbit_port > 0 && this.rabbit_tiempo > 0) {


                        let jsonInfo = {
                            rabbit_host: this.rabbit_host,
                            rabbit_port: this.rabbit_port,
                            rabbit_user: this.rabbit_user,
                            rabbit_pass: this.rabbit_pass,
                            // Se mantiene nombre del parámetro para coincidir con la DB de instalaciones existentes
                            rabbit_exchange: this.rabbit_exchange,
                            rabbit_tiempo: this.rabbit_tiempo
                        }

                        if (this._idBucket) {

                            this.textoModal = "MODIFICANDO DATOS Y ESTABLECIENDO NUEVA CONEXIÓN A RABBITMQ";
                            this.bandModalGuardado = true;

                            let resp = await this.axios.put("./api" + "/configParams/" + this._idBucket, jsonInfo);
                            this.bandModalGuardado = false;

                            if (resp.data && resp.data.respReconexion) {
                                if (resp.data.respReconexion == 'conexionRealizada') {
                                    notify("MODIFICACIÓN Y CONEXIÓN A RABBITMQ EXITOSA", "success", 3000);
                                } else {
                                    notify("MODIFICACIÓN EXITOSA PERO FALLÓ LA CONEXIÓN A RABBITMQ", "warning", 3000);
                                }
                            } else {
                                notify("MODIFICACIÓN EXITOSA", "success", 3000);
                            }

                        } else {

                            this.textoModal = "GUARDANDO DATOS Y ESTABLECIENDO CONEXIÓN A RABBITMQ";
                            this.bandModalGuardado = true;

                            let resp = await this.axios.post("./api" + "/configParams", jsonInfo);
                            this.bandModalGuardado = false;

                            if (resp.data && resp.data.respReconexion) {
                                if (resp.data.respReconexion == 'conexionRealizada') {
                                    notify("GUARDADO Y CONEXIÓN A RABBITMQ REALIZADO DE FORMA EXITOSA", "success", 3000);
                                } else {
                                    notify("GUARDADO EXITOSO PERO FALLÓ LA CONEXIÓN A RABBITMQ", "warning", 3000);
                                }
                            } else {
                                notify("GUARDADO EXITOSO", "success", 3000);
                            }

                        }

                        this.$router.push({ name: 'articulos' });

                    } else {
                        notify("LOS VALORES NUMÉRICOS DEBEN SER MAYORES A 0", "warning", 3000);
                    }

                } else {
                    notify("COMPLETE TODOS LOS CAMPOS PARA PODER GUARDAR", "warning", 3000);
                }

            } catch (error) {
                this.bandModalGuardado = false;
                console.log("ERROR TRY CATCH ----");
                console.error(error);
                notify("ERROR", "error", 3000);
            }
        }
    },
}

</script>